module.exports = __webpack_public_path__ + "img/speaker.328aa519.svg";